import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { CreateCohort } from 'components/product/components/createCohort';
import { UploadCohortCustomers } from 'components/product/components/uploadCohortCustomers';
import { ViewCohort } from 'components/product/components/viewCohort';
import { ViewCohortCustomers } from 'components/product/components/viewCohortCustomers';
import { TabPanel } from 'shared';

function Cohort() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="View cohorts" value="0" />
                <Tab label="Cohort customers" value="1" />
                <Tab label="Upload customers" value="2" />
                <Tab label="Create cohort" value="3" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewCohort />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <ViewCohortCustomers />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <UploadCohortCustomers />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="3">
                <CreateCohort />
            </TabPanel>
        </Paper>
    );
}

export { Cohort };
